import React, {useRef} from 'react'
import './CloseButton.less'
import {Icon, IconName} from "./Icon"

interface CloseButtonProps {
  onClose: () => void
  tooltipText?: string
  className?: string
}

export const CloseButton: React.FC<CloseButtonProps> = ({
  onClose,
  tooltipText = 'Close',
  className = ''
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null)

  const handleClick = () => {
    onClose()
  }

  return (
    <div className={`close-button-container ${className}`}>
      <button
        ref={buttonRef}
        className="close-button"
        onClick={handleClick}
        aria-label="Close"
        title={tooltipText}
      >
        <Icon
          name={IconName.Cancel}
          className="close-icon"
          width="20"
          height="20"
        />
      </button>
    </div>
  )
}
